var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9474 6.91667C11.9474 10.6304 7.56842 14.5 6.47368 14.5C5.37895 14.5 1 10.6304 1 6.91667C1 3.92512 3.45065 1.5 6.47368 1.5C9.49672 1.5 11.9474 3.92512 11.9474 6.91667Z",
    stroke: "#BE7637",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.05263,
    cy: 2.05263,
    r: 2.05263,
    transform: "matrix(-1 0 0 1 8.52637 4.5791)",
    stroke: "#BE7637",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.9c2206eaf863ee6c4dff93fb491337aa.svg";
export { ForwardRef as ReactComponent };